import {createContext, FC, PropsWithChildren, useRef} from 'react';

import {DatatableStore, createDatatableStore, DatatableProps} from '@common/stores/datatableStore';

type DatatableStoreProviderProps = PropsWithChildren<DatatableProps>;

export const DatatableContext = createContext<DatatableStore | null>(null);

const DatatableStoreProvider: FC<DatatableStoreProviderProps> = ({children, ...props}) => {
  const storeRef = useRef<DatatableStore>();
  if (!storeRef.current) {
    storeRef.current = createDatatableStore(props);
  }
  return <DatatableContext.Provider value={storeRef.current}>{children}</DatatableContext.Provider>;
};

export default DatatableStoreProvider;
